import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { interceptorProviders } from './@shared/interceptors/interceptors';
import { RoutePlannerModule } from './modules/route-planner/route-planner.module';
import { SharedModule } from './@shared/shared.module';
import { environment } from 'src/environments/environment';
import {
  SURVEY_API_BASE_URL,
  normalizeSurveyApiBaseUrl,
} from './@shared/survey/survey-api-base-url.token';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    RoutePlannerModule,
    SharedModule,
  ],
  providers: [
    interceptorProviders,
    {
      provide: SURVEY_API_BASE_URL,
      useValue: normalizeSurveyApiBaseUrl(environment.bo_be_service_url),
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
